import { queryParam } from 'utils/queryString';

const initialState = {
  redirectTo: queryParam('to')
};

/**
 * Redirection reducer
 * @param {Object} state
 * @param {Object} action
 * @return {Object}
 */
export default function redirectionReducer(state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
